import { render } from "./observer.vue?vue&type=template&id=cdbce022&ts=true"
import script from "./observer.vue?vue&type=script&lang=ts"
export * from "./observer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__